import { compact } from 'lodash-es';
import { extractPureTextFromRichText } from 'seagull';
import { approvalMethodNoticePeriodModel, relationshipModel } from '~/models';
import { requestAccountantAccessModel } from '~/models/request-accountant-access';
const hasAgreementNotes = (extraClause)=>!!extraClause && extractPureTextFromRichText(extraClause).trim().length > 0;
export const getAdditionalTermsData = (relationship)=>{
    var _relationship_extraClause;
    return compact([
        {
            key: 'effectiveDate',
            title: 'Effective date of agreement',
            description: relationshipModel.formatEffectiveDate(relationship)
        },
        {
            key: 'paymentTerms',
            title: 'Payment terms',
            description: relationshipModel.paymentTermsText(relationship)
        },
        {
            key: 'amendments',
            title: 'Amendments',
            description: approvalMethodNoticePeriodModel.amendmentsDescription(relationship.amendmentsApprovalMethod)
        },
        approvalMethodNoticePeriodModel.isAutoApproval(relationship.invoicesApprovalMethod) && {
            key: 'outOfScopeCharges',
            title: 'Out of scope charges',
            description: approvalMethodNoticePeriodModel.invoicesDescription(relationship.invoicesApprovalMethod)
        },
        requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess) && {
            key: 'accountantAccess',
            title: 'Accountant Access',
            description: "Will allow the ".concat(relationship.vendor.name, " team to view your account information on Anchor, including invoices, agreements, and payments, as well as manage your payment methods.")
        },
        hasAgreementNotes(relationship.extraClause) && {
            key: 'agreementNotes',
            title: 'Agreement notes',
            description: (_relationship_extraClause = relationship.extraClause) !== null && _relationship_extraClause !== void 0 ? _relationship_extraClause : ''
        }
    ]);
};
